var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        { staticClass: "px-2", attrs: { cols: "12", sm: "6", md: "3" } },
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            [
              _c(
                "v-col",
                [
                  _c("date-picker", {
                    staticClass: "px-2",
                    attrs: {
                      "prepend-icon": "fa-calendar",
                      model: _vm.contextFromDate,
                      clearable: true,
                      label: _vm.$t("global.fromDate")
                    },
                    on: {
                      "update:model": function($event) {
                        _vm.contextFromDate = $event
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                [
                  _c("date-picker", {
                    staticClass: "px-2",
                    attrs: {
                      "prepend-icon": "fa-calendar",
                      model: _vm.contextToDate,
                      clearable: true,
                      label: _vm.$t("global.toDate")
                    },
                    on: {
                      "update:model": function($event) {
                        _vm.contextToDate = $event
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-col",
        { staticClass: "px-2", attrs: { cols: "12", sm: "6", md: "2" } },
        [
          _c("v-select", {
            attrs: {
              multiple: "",
              "prepend-icon": "fa-hand-holding-usd",
              label: _vm.$t("global.serviceTypes"),
              "hide-details": "",
              "small-chips": "",
              items: _vm.availableServiceTypes,
              "item-text": "name",
              "item-value": "type"
            },
            scopedSlots: _vm._u([
              {
                key: "selection",
                fn: function(ref) {
                  var item = ref.item
                  var index = ref.index
                  return [
                    index === 0
                      ? _c(
                          "v-chip",
                          {
                            attrs: { color: "primary", "text-color": "white" }
                          },
                          [
                            item.name.length < 13
                              ? _c("span", [
                                  _vm._v(" " + _vm._s(item.name) + " ")
                                ])
                              : _c("span", [
                                  _vm._v(
                                    " " +
                                      _vm._s(item.name.substring(0, 13)) +
                                      "... "
                                  )
                                ])
                          ]
                        )
                      : _vm._e(),
                    index === 1
                      ? _c("span", { staticClass: "grey--text caption" }, [
                          _vm._v(
                            "(+" +
                              _vm._s(_vm.selectedTypes.length - 1) +
                              " " +
                              _vm._s(_vm.$t("global.others")) +
                              ")"
                          )
                        ])
                      : _vm._e()
                  ]
                }
              }
            ]),
            model: {
              value: _vm.contextSelectedTypes,
              callback: function($$v) {
                _vm.contextSelectedTypes = $$v
              },
              expression: "contextSelectedTypes"
            }
          })
        ],
        1
      ),
      _c(
        "v-col",
        { staticClass: "px-2", attrs: { cols: "6", sm: "6", md: "2" } },
        [
          _c("v-checkbox", {
            attrs: { label: _vm.$t("global.expandAll") },
            model: {
              value: _vm.contextShowAll,
              callback: function($$v) {
                _vm.contextShowAll = $$v
              },
              expression: "contextShowAll"
            }
          })
        ],
        1
      ),
      _c("v-spacer"),
      _c(
        "v-col",
        { staticClass: "px-2", attrs: { cols: "12", sm: "6", md: "3" } },
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            [
              _c("booking-column-select", {
                staticStyle: { "max-width": "80%" },
                attrs: {
                  "available-columns": _vm.availableColumns,
                  "selected-columns": _vm.contextSelectedColumns
                },
                on: {
                  "update:availableColumns": function($event) {
                    _vm.availableColumns = $event
                  },
                  "update:available-columns": function($event) {
                    _vm.availableColumns = $event
                  },
                  "update:selectedColumns": function($event) {
                    _vm.contextSelectedColumns = $event
                  },
                  "update:selected-columns": function($event) {
                    _vm.contextSelectedColumns = $event
                  }
                }
              }),
              _vm.downloadable
                ? _c(
                    "v-tooltip",
                    {
                      attrs: { bottom: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    {
                                      staticClass: "mt-3",
                                      attrs: {
                                        disabled:
                                          _vm.$store.getters["Ajax/loading"],
                                        icon: "",
                                        large: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.$emit("download")
                                        }
                                      }
                                    },
                                    on
                                  ),
                                  [
                                    _c("v-icon", { attrs: { large: "" } }, [
                                      _vm._v("cloud_download")
                                    ])
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        4065027427
                      )
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("global.downloadFile")) + " ")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }